// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"1511c96f","103":"5a6017e4","526":"17a7eb75","732":"34fd3767","880":"e8d4c08a","977":"5b99e0fa"}[chunkId] + ".chunk.js";
};